import { Option } from '@mews-commander/types';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { ContractTemplateStatus } from '@mews-commander/data-access';

export const TEMPLATE_STATUS_OPTIONS: Option<ContractTemplateStatus>[] = [
    createOption({
        value: ContractTemplateStatus.UpToDate,
        label: lt('ContractTemplateUpToDateLabel'),
    }),
    createOption({
        value: ContractTemplateStatus.TemplateUnavailable,
        label: lt('ContractTemplateUnavailableLabel'),
    }),
    createOption({
        value: ContractTemplateStatus.NewVersionAvailable,
        label: lt('ContractTemplateModifiedLabel'),
    }),
];
